import { useQuery } from "@tanstack/react-query";
import useChartColors from "Common/useChartColors";
import React from "react";
import ReactApexChart from "react-apexcharts";
import { getRevenue } from "services/apiDashboard";

const OrdersOverviewChart = ({ chartId }: any) => {
  const chartColors = useChartColors(chartId);
  const user = localStorage.getItem("user")
    ? JSON.parse(localStorage.getItem("user") as string)
    : null;

  const {
    isLoading,
    data: revenue,
    error,
  } = useQuery({
    queryKey: ["revenue", { id: user?.id }],
    queryFn: () => getRevenue({ id: user?.id }),
    enabled: !!user?.id,
  });

  if (isLoading) {
    return <p>Loading...</p>;
  }

  if (error) {
    return <p>Error loading data.</p>;
  }

  if (!revenue || revenue.length === 0) {
    return <p>No revenue data available.</p>;
  }

  const series = [
    {
      name: "Revenue",
      data: revenue,
    },
  ];

  const options: any = {
    chart: {
      height: 238,
      type: "bar",
      toolbar: {
        show: false,
      },
    },
    plotOptions: {
      bar: {
        borderRadius: 5,
        dataLabels: {
          position: "top",
        },
      },
    },
    dataLabels: {
      enabled: true,
      formatter: (val: any) => `${val.toLocaleString()}`,
      style: {
        fontSize: "11px",
      },
    },
    grid: {
      padding: {
        bottom: -10,
      },
    },
    xaxis: {
      categories: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
      position: "top",
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
      tooltip: {
        enabled: true,
      },
    },
    yaxis: {
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
      labels: {
        show: false,
        formatter: (val: any) => `${val.toLocaleString()}`,
      },
    },
    colors: [
      "#FF5733", // Color for Jan
      "#33FF57", // Color for Feb
      "#3357FF", // Color for Mar
      "#FF33A1", // Color for Apr
      "#A133FF", // Color for May
      "#33FFF1", // Color for Jun
      "#FFBB33", // Color for Jul
      "#33FFBB", // Color for Aug
      "#BB33FF", // Color for Sep
      "#FF5733", // Color for Oct
      "#FF5733", // Color for Nov
      "#33BBFF", // Color for Dec
    ],
  };

  return (
    <React.Fragment>
      <ReactApexChart
        dir="ltr"
        options={options}
        series={series}
        data-chart-colors='["bg-custom-500"]'
        id={chartId}
        className="apex-charts"
        type="bar"
        height={238}
      />
    </React.Fragment>
  );
};

export { OrdersOverviewChart };
